import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klpkonsern/routing';
import type { Bruker } from '@klp/user';
export const ReportModuleName = 'report';

export const ReportRoutes = {
    moduleRoute: () => generateRoute([ReportModuleName]),
    reportList: () => generateRoute([ReportModuleName]),
};

export const ReportAccess = (user: Bruker | undefined): boolean =>
    Boolean(user && user.isAdmin);

export const ReportMenuItems = [
    new SidebarMenuItem({
        route: ReportRoutes.reportList(),
        matchRoute: ReportRoutes.moduleRoute(),
        icon: IconName.GRAPH,
        translation: 'report.title',
        access: ReportAccess,
    }),
];
